import { useEffect, useState } from 'react';

export function useCameraStream(enabled = true) {
  const [stream, setStream] = useState<MediaStream>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!enabled) return;
    let mounted = true;
    let activeStream: MediaStream | undefined;

    if (!navigator.mediaDevices?.getUserMedia) {
      setError('Camera access is unavailable in this browser or insecure context.');
      return;
    }

    void navigator.mediaDevices
      .getUserMedia({
        video: { width: { ideal: 1280 }, height: { ideal: 720 }, facingMode: 'user' },
        audio: { noiseSuppression: true, echoCancellation: true }
      })
      .then((mediaStream) => {
        activeStream = mediaStream;
        if (mounted) {
          setStream(mediaStream);
        } else {
          mediaStream.getTracks().forEach((track) => track.stop());
        }
      })
      .catch((err: unknown) => {
        if (mounted) setError(err instanceof Error ? err.message : 'Unable to access camera');
      });

    return () => {
      mounted = false;
      activeStream?.getTracks().forEach((track) => track.stop());
    };
  }, [enabled]);

  return { stream, error };
}
